import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWorkWithDocuments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 61 70"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M55.667 36.667v-19c0-5.6 0-8.401-1.09-10.54a10 10 0 0 0-4.37-4.37c-2.14-1.09-4.94-1.09-10.54-1.09H18.333c-5.6 0-8.4 0-10.54 1.09a10 10 0 0 0-4.37 4.37c-1.09 2.139-1.09 4.94-1.09 10.54v34.666c0 5.6 0 8.401 1.09 10.54a10 10 0 0 0 4.37 4.37c2.14 1.09 4.94 1.09 10.54 1.09H29m6.667-36.666h-20M22.333 45h-6.666m26.666-26.667H15.667m21.666 40L44 65l15-15"
    />
  </svg>
);
export default SvgWorkWithDocuments;
